import React, { useState, useEffect } from "react";

function AddMemberModal({
  isOpen,
  onClose,
  onAddMember,
  membersNotInGroup = [], // users NOT in group
  membersAlreadyInGroup = {},
  onRemoveMember, // optional, for removing members already in group if you want
}) {
  // When modal opens, reset selectedMembers to current membersAlreadyInGroup

  const [selectedMembers, setSelectedMembers] = useState([]);
  const [username, setUsername] = useState("");
  const [searchResults, setSearchResults] = useState([]);
  const [isSearching, setIsSearching] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (isOpen) {
      const initialSelected = Object.entries(membersAlreadyInGroup).map(
        ([id, user]) => ({
          id,
          ...user,
        }),
      );
      setSelectedMembers(initialSelected);
      setUsername("");
      setSearchResults([]);
    }
  }, [isOpen, membersAlreadyInGroup]);

  // Search usersNotInGroup based on username input
  useEffect(() => {
    if (!username) {
      setSearchResults([]);
      return;
    }
    setIsSearching(true);
    // Simulate search filtering by name or email or username (adjust fields as needed)
    const filtered = membersNotInGroup.filter((user) => {
      const name = user.name || user.full_name || "";
      return name.toLowerCase().includes(username.toLowerCase());
    });
    setSearchResults(filtered);
    setIsSearching(false);
  }, [username, membersNotInGroup]);

  // When user clicks a search result to add to selected
  const handleSelectUser = (user) => {
    if (selectedMembers.find((m) => m.id === user.id)) return; // avoid duplicates
    setSelectedMembers((prev) => [...prev, user]);
    setUsername("");
    setSearchResults([]);
  };

  // Remove selected member
  const handleRemoveSelectedMember = (id) => {
    setSelectedMembers((prev) => prev.filter((m) => m.id !== id));
  };

  // Save selected members and call onAddMember callback
  const handleSave = () => {
    if (selectedMembers.length === 0) return;
    setIsLoading(true);
    onAddMember(selectedMembers);
    // Optionally clear after adding
    setSelectedMembers([]);
    setIsLoading(false);
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="modal delete-account-modal fade show d-block" tabIndex="-1">
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header mb-4 d-flex justify-content-center align-items-center">
            <h1 className="modal-title text-heading-chat-modal new-message-heading">
              Add Group Members
            </h1>
            <button
              type="button"
              className="btn-close btn-close-white position-absolute end-0 me-3"
              onClick={onClose}
              aria-label="Close"
            ></button>
          </div>
          <div className="modal-body">
            <div className="row gap-4">
              <div
                className="add-member-section"
                style={{ backgroundColor: "#132534" }}
              >
                <form
                  onSubmit={(e) => {
                    e.preventDefault();
                    if (searchResults.length === 1) {
                      handleSelectUser(searchResults[0]);
                    }
                  }}
                >
                  <div className="form-group mb-4 px-3 pt-3">
                    <label htmlFor="username" className="text-white">
                      Search and add members
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="username"
                      placeholder="Enter username"
                      value={username}
                      onChange={(e) => setUsername(e.target.value)}
                      required
                      autoComplete="off"
                    />
                    {isSearching && (
                      <div className="text-light mt-1">Searching...</div>
                    )}
                    {searchResults.length > 0 && (
                      <div
                        className="bg-dark text-white p-2 rounded mt-1"
                        style={{ maxHeight: 200, overflowY: "auto", minHeight: 150 }}
                      >
                        {searchResults.map((user) => (
                          <div
                            key={user.id}
                            className="search-result-item py-2 px-2 hover-bg d-flex align-items-center gap-2"
                            style={{ cursor: "pointer" }}
                            onClick={() => handleSelectUser(user)}
                          >
                            <img
                              src={user.profileImage || user.image || "/icons/group-user.svg"}
                              alt={user.name || user.full_name || "Unknown"}
                              style={{
                                width: "30px",
                                height: "30px",
                                borderRadius: "50%",
                                objectFit: "cover",
                              }}
                            />
                            <span>{user.name || user.full_name || "Unknown"}</span>
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                </form>

                <div
                  className="member-container px-3 pb-3"
                  style={{ height: "auto" }}
                >
                  {/* <h6 className="text-white mb-2">Selected Members:</h6> */}
                  {selectedMembers.length === 0 ? (
                    <p className="text-white">No members selected yet</p>
                  ) : (
                    <div className="d-flex flex-wrap align-items-center gap-2">
                      {selectedMembers.map((member) => (
                        <div
                          className="member-chip d-flex align-items-center bg-secondary text-white px-2 py-1 rounded"
                          key={member.id}
                          style={{
                            maxWidth: "100%",
                            minWidth: "100px",
                            width: "auto",
                            flexShrink: 0,
                          }}
                        >
                          {/* <img
                            src={member.profileImage || "/icons/default-avatar.svg"}
                            alt={member.name}
                            className="member-avatar me-1"
                            style={{ width: 24, height: 24, borderRadius: "50%", flexShrink: 0 }}
                          /> */}
                          <span
                            className="member-name me-1 text-truncate"
                            style={{
                              whiteSpace: "nowrap",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              maxWidth: "150px",
                              display: "inline-block",
                            }}
                          >
                            {member.name || member.full_name || "Unknown"}
                          </span>
                          <img
                            src="/icons/cross.svg"
                            alt="Remove"
                            style={{
                              width: "10px",
                              height: "10px",
                              cursor: "pointer",
                              flexShrink: 0,
                            }}
                            onClick={() =>
                              handleRemoveSelectedMember(member.id)
                            }
                          />
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              </div>
            </div>

            <div className="d-flex gap-3 mt-4 justify-content-center">
              <button
                className="btn-1 btn-1-primary px-3"
                style={{ width: "182px" }}
                onClick={handleSave}
                disabled={isLoading || selectedMembers.length === 0}
              >
                {isLoading ? "Saving..." : "Save"}
              </button>
              <button
                className="btn-1 btn-1-primary px-3"
                style={{ width: "182px", backgroundColor: "#eb5757" }}
                onClick={onClose}
                disabled={isLoading}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AddMemberModal;
